import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RapoarteComponent } from './rapoarte.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [RapoarteComponent],
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [RapoarteComponent]
})
export class RapoarteModule { }
